import { useQuery } from "@tanstack/react-query";
import { AdminService } from "../servcies/admin.service";
import { ToastService } from "@shared/lib/services";
import { useEffect } from "react";
import { ADMIN_PERMISSION_QUERY_KEY } from "../constants/";
import { BackednResponse, PermissionsConst } from "@shared/lib/types";

export function useGetAdminPermissions() {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<PermissionsConst>
  >({
    queryKey: ADMIN_PERMISSION_QUERY_KEY,
    queryFn: () => AdminService.getPermissionsConst(),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    adminPermissions: data?.data,
    isError,
    isFetching: isLoading,
  };
}
